/*
 * Título de una sección del tablero con el botón "Exportar a Excel" a la derecha (solo con el permiso
 * generate_report_attendance: el contenedor pasa canExport). `exportParams` son los parámetros de
 * GET /attendance/exportar/ (filtros de la pantalla + seccion, y agrupar en Horas).
 */
import React from "react";
import ExportButton from "./ExportButton";

const SectionHeader = ({id, title, canExport, token, exportParams, range}) => (
    <div className="mc-section__head">
        <h2 id={id} className="mc-section__title">{title}</h2>
        {canExport && <ExportButton token={token} params={exportParams} range={range}/>}
    </div>
);

export default SectionHeader;
